module.exports = __webpack_public_path__ + "img/lg_ring_g_skip_null_0@2x.f3340e60.png";